import React from "react";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Button from '@mui/material/Button';
import { makeStyles } from "@material-ui/core/styles";
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import SpotReviewComposer from "./SpotReviewComposer";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: theme.shadows[10],
    padding: theme.spacing(3, 2, 3),
    width: '95vw',
    maxWidth: 680,
    height: '90vh',
    maxHeight: 600,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    outline: 'none',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3, 4, 3),
    },
  },
}));


const SpotReviewComposerModal = ({ id, isDraft, parentId, relation, onDraftSubmit, triggerLabel, triggerSx, editReview, externalOpen, onExternalClose, allowFutureDates }) => {
  const classes = useStyles();
  const [internalOpen, setInternalOpen] = React.useState(false);

  // Support both internal trigger (button) and external open control (from detail page).
  const open = externalOpen != null ? externalOpen : internalOpen;
  const handleOpen = (e) => {
    e.preventDefault();
    setInternalOpen(true);
  };
  const handleClose = (e) => {
    if (e) e.preventDefault();
    if (onExternalClose) onExternalClose();
    setInternalOpen(false);
  };

  return (
    <div>
      {externalOpen == null && (
        <Button
          variant="outlined"
          startIcon={<AddLocationAltIcon sx={{ fontSize: 28 }} />}
          onClick={handleOpen}
          sx={triggerSx || {
            width: '100%',
            height: { xs: 120, sm: 180 },
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '1rem',
            borderStyle: 'dashed',
            borderWidth: 2,
            color: 'primary.main',
            borderColor: 'primary.light',
            '&:hover': { borderStyle: 'dashed', borderWidth: 2, bgcolor: 'primary.50' },
          }}
        >
          {triggerLabel || 'Add an Activity'}
        </Button>
      )}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <SpotReviewComposer
              isDraft={isDraft}
              onClose={() => handleClose()}
              parentId={parentId}
              relation={relation}
              onDraftSubmit={onDraftSubmit}
              editReview={editReview}
              allowFutureDates={allowFutureDates}
            />
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default SpotReviewComposerModal;
